import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import Restaurant from "./pages/Restaurant";
import Carte from "./pages/Carte";
import Traiteur from "./pages/Traiteur";
import Galerie from "./pages/Galerie";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import Cgv from "./pages/Cgv";
import Cgu from "./pages/Cgu";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import NotFound from "./pages/NotFound";
import Merci from "./pages/Merci";

function App() {
  const [cookieSignal, setCookieSignal] = useState(0);

  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/restaurant" element={<Restaurant />} />
              <Route path="/carte" element={<Carte />} />
              <Route path="/traiteur" element={<Traiteur />} />
              <Route path="/galerie" element={<Galerie />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/conditions-generales-de-vente" element={<Cgv />} />
              <Route path="/conditions-generales-utilisation" element={<Cgu />} />
              <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/merci" element={<Merci />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer onManageCookies={() => setCookieSignal((s) => s + 1)} />
          <CookieBanner openSignal={cookieSignal} />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
